"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var _ = require("lodash");
var ui_1 = require("@vidazoo/ui");
var PasswordForm = /** @class */ (function (_super) {
    tslib_1.__extends(PasswordForm, _super);
    function PasswordForm(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.checkPassword = function (password) {
            var checkPassword = _this.props.checkPassword;
            _this.setState({ changingPassword: false });
            checkPassword(password);
        };
        _this.onChange = function (e) {
            var _a;
            var nextState = (_a = {},
                _a[e.target.name] = e.target.value,
                _a);
            if (e.target.name === "newPassword") {
                !nextState.changingPassword && (nextState.changingPassword = true);
                _this.checkPassword(e.target.value);
            }
            _this.setState(nextState);
        };
        _this.onSubmit = function () {
            var onUpdate = _this.props.onUpdate;
            var _a = _this.state, currentPassword = _a.currentPassword, newPassword = _a.newPassword;
            if (_this.disableButton) {
                return;
            }
            onUpdate(currentPassword, newPassword);
        };
        _this.state = { currentPassword: "", newPassword: "", confirmPassword: "", changingPassword: false };
        _this.checkPassword = _.debounce(_this.checkPassword, 500, { trailing: true });
        return _this;
    }
    Object.defineProperty(PasswordForm.prototype, "disableButton", {
        get: function () {
            var _a = this.props, isCheckingPassword = _a.isCheckingPassword, passwordScore = _a.passwordScore;
            var _b = this.state, newPassword = _b.newPassword, confirmPassword = _b.confirmPassword;
            return isCheckingPassword || !newPassword || (newPassword !== confirmPassword) || passwordScore < 3;
        },
        enumerable: true,
        configurable: true
    });
    PasswordForm.prototype.render = function () {
        var _a = this.props, onCancel = _a.onCancel, isCheckingPassword = _a.isCheckingPassword, passwordScore = _a.passwordScore;
        var _b = this.state, currentPassword = _b.currentPassword, newPassword = _b.newPassword, confirmPassword = _b.confirmPassword, changingPassword = _b.changingPassword;
        return (React.createElement(ui_1.Form, { className: theme.password, onSubmit: this.onSubmit },
            React.createElement(ui_1.Label, { className: theme.label, spacing: 1.25, size: 13, weight: 600 }, "Update Password"),
            React.createElement(ui_1.AggregateChangeComponent, { onChange: this.onChange },
                React.createElement(ui_1.FormInput, { type: "password", className: theme.input, value: currentPassword, name: "currentPassword", label: "Current Password", required: true, fill: true, autoFocus: true, autoComplete: "nope" }),
                React.createElement(ui_1.FormInput, { type: "password", className: theme.input, value: newPassword, name: "newPassword", label: "New Password", required: true, fill: true, autoComplete: "nope" }),
                React.createElement(ui_1.PasswordStrength, { className: theme.strenght, score: passwordScore, isChecking: isCheckingPassword || changingPassword }),
                React.createElement(ui_1.FormInput, { type: "password", className: theme.input, value: confirmPassword, name: "confirmPassword", label: "Confirm Password", required: true, fill: true, autoComplete: "nope" })),
            React.createElement("div", { className: theme.options },
                React.createElement(ui_1.Button, { type: "button", medium: true, gray: true, onClick: onCancel }, "Cancel"),
                React.createElement(ui_1.Button, { type: "submit", disabled: this.disableButton, medium: true, blue: true }, "Update Password"))));
    };
    PasswordForm.defaultProps = {};
    return PasswordForm;
}(React.Component));
exports.default = PasswordForm;
